import $fetch from '../../../fetch';
import { API_BASE_URL, parseResponseData } from '../../utils';
import {
  FetchInviteUserDetailParams,
  ImpersonateUserParams,
  UpdateProfileParams,
} from './user.requests.types';
import userResponseSchemas from './user.responses.schemas';

const BASE_SERVICE_URL = `${API_BASE_URL}/user` as const;

export async function fetchMe() {
  const response = await $fetch(`${API_BASE_URL}/me`);

  const data = parseResponseData(response, userResponseSchemas.fetchMe);
  return data;
}

export async function impersonateUser(params: ImpersonateUserParams) {
  const response = await $fetch(
    `${BASE_SERVICE_URL}/impersonate/${params.userId}`
  );

  const data = parseResponseData(response, userResponseSchemas.impersonateUser);

  return data;
}

export async function fetchInviteUserDetail(
  params: FetchInviteUserDetailParams
) {
  const { token } = params;

  const response = await $fetch(
    `${BASE_SERVICE_URL}/inviteuserdetail/${token}`
  );

  const data = parseResponseData(
    response,
    userResponseSchemas.fetchInviteUserDetail
  );

  return data;
}

export async function updateProfile(params: UpdateProfileParams) {
  const response = await $fetch(`${BASE_SERVICE_URL}/updateprofile`, {
    method: 'PUT',
    body: JSON.stringify(params),
  });

  const data = parseResponseData(response, userResponseSchemas.updateProfile);

  return data;
}
